 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"branches":"branches","contact-us~documents~forums~local-hosts~newsletter~organizers~pages~panels~partners~pre-works~record~585166e8":"contact-us~documents~forums~local-hosts~newsletter~organizers~pages~panels~partners~pre-works~record~585166e8","contact-us":"contact-us","documents":"documents","forums~panels~practical_matters":"forums~panels~practical_matters","forums":"forums","panels":"panels","local-hosts":"local-hosts","newsletter":"newsletter","organizers":"organizers","pages":"pages","partners":"partners","pre-works":"pre-works","recordings":"recordings","sessionDays":"sessionDays","sessionTopics":"sessionTopics","sessions":"sessions","speakers":"speakers","sponsors":"sponsors","virtual-courses":"virtual-courses","content-pages":"content-pages","practical_matters":"practical_matters","mediaInfo":"mediaInfo","permissions":"permissions","redirection-pages":"redirection-pages","roles":"roles","settings":"settings","users":"users"}[chunkId]||chunkId) + "." + {"branches":"921f811c","chunk-2d219ff9":"8a6736cd","contact-us~documents~forums~local-hosts~newsletter~organizers~pages~panels~partners~pre-works~record~585166e8":"a5ac81a9","contact-us":"dd162eb2","documents":"5d773e68","forums~panels~practical_matters":"cb123ebe","forums":"89d308c7","panels":"b809b56e","local-hosts":"def321ca","newsletter":"1dbff5d5","organizers":"66c84b8a","pages":"af947b06","partners":"0f7a5192","pre-works":"af021f9d","recordings":"88ce3428","sessionDays":"402c8ffb","sessionTopics":"7019abe3","sessions":"c96dd7f3","speakers":"1d10713e","sponsors":"908700a3","virtual-courses":"037ee142","content-pages":"d3a80791","practical_matters":"2bfa1050","mediaInfo":"64b4625f","permissions":"932133a1","redirection-pages":"7360f421","roles":"83d5db99","settings":"5454eda3","users":"7367e10e","chunk-2d216214":"1f54003d","chunk-2d216257":"58872a85","chunk-84bd5380":"94b145a7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"contact-us":1,"documents":1,"forums~panels~practical_matters":1,"forums":1,"panels":1,"local-hosts":1,"organizers":1,"partners":1,"pre-works":1,"recordings":1,"sessionDays":1,"sessionTopics":1,"sessions":1,"speakers":1,"sponsors":1,"virtual-courses":1,"content-pages":1,"practical_matters":1,"roles":1,"users":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"branches":"branches","contact-us~documents~forums~local-hosts~newsletter~organizers~pages~panels~partners~pre-works~record~585166e8":"contact-us~documents~forums~local-hosts~newsletter~organizers~pages~panels~partners~pre-works~record~585166e8","contact-us":"contact-us","documents":"documents","forums~panels~practical_matters":"forums~panels~practical_matters","forums":"forums","panels":"panels","local-hosts":"local-hosts","newsletter":"newsletter","organizers":"organizers","pages":"pages","partners":"partners","pre-works":"pre-works","recordings":"recordings","sessionDays":"sessionDays","sessionTopics":"sessionTopics","sessions":"sessions","speakers":"speakers","sponsors":"sponsors","virtual-courses":"virtual-courses","content-pages":"content-pages","practical_matters":"practical_matters","mediaInfo":"mediaInfo","permissions":"permissions","redirection-pages":"redirection-pages","roles":"roles","settings":"settings","users":"users"}[chunkId]||chunkId) + "." + {"branches":"31d6cfe0","chunk-2d219ff9":"31d6cfe0","contact-us~documents~forums~local-hosts~newsletter~organizers~pages~panels~partners~pre-works~record~585166e8":"31d6cfe0","contact-us":"d0b77e0e","documents":"6f935c1b","forums~panels~practical_matters":"de8a7b56","forums":"2df00398","panels":"7002ff4c","local-hosts":"6f935c1b","newsletter":"31d6cfe0","organizers":"6f935c1b","pages":"31d6cfe0","partners":"6f935c1b","pre-works":"6f935c1b","recordings":"e3f87b97","sessionDays":"bc577e06","sessionTopics":"bc577e06","sessions":"bc577e06","speakers":"6f935c1b","sponsors":"6f935c1b","virtual-courses":"bc577e06","content-pages":"6f935c1b","practical_matters":"7002ff4c","mediaInfo":"31d6cfe0","permissions":"31d6cfe0","redirection-pages":"31d6cfe0","roles":"11f5dce6","settings":"31d6cfe0","users":"559fd49d","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-84bd5380":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
